function getValue (value) {
  return value === undefined
    ? ''
    : typeof value === 'function'
      ? value()
      : value
}

export default function transformProps (props) {
  let propsForModel = Object.keys(props)
    .reduce((res, current) => {
      res[current] = getValue(props[current].value)
      return res
    }, {})

  let propsForStory = {}

  try {
    propsForStory = Object.keys(props)
      .reduce((res, current) => {
        let { type, value } = props[current]
        if (typeof type === 'function' && value !== undefined) {
          let from = type.name.toLowerCase()
          let to = ''
          switch (from) {
            case 'string':
              to = 'text'
              break
            case 'number':
              to = 'number'
              break
            case 'object':
              to = 'object'
              break
            case 'array':
              to = 'object'
              break
            case 'boolean':
              to = 'boolean'
              break
          }
          if (to) {
            res[current] = [to, getValue(value)]
          }
        }
        return res
      }, {})
  } catch (err) {
  }

  return {
    propsForView: props,
    propsForModel,
    propsForStory
  }
}
